import { FILTERS } from '@Constants/types';

export function setSortFlags(sortingInputs) {
    return dispatch =>
        dispatch({
            type: FILTERS.UPDATE_SORTING,
            payload: sortingInputs
        });
}

export function setAnswerFlags(answerFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_ANSWERS,
            payload: answerFlags
        });
}

export function setSuggestedClauseFlags(suggestedClauseFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_SUGGESTED_CLAUSES,
            payload: suggestedClauseFlags
        });
}
export function setExtractionsFlags(extractionsFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_EXTRACTIONS,
            payload: extractionsFlags
        });
}

export function setRiskFlags(riskFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_RISK_LEVELS,
            payload: riskFlags
        });
}

export function setTopicFlags(topicFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_TOPICS,
            payload: topicFlags
        });
}
export function setSubTopicFlags(subTopicFlags) {
    return dispatch =>
        dispatch({
            type: FILTERS.FILTER_BY_SUBTOPICS,
            payload: subTopicFlags
        });
}
export function resetAllFilterFlags() {
    return dispatch =>
        dispatch({
            type: FILTERS.RESET_FILTERS
        });
}
